import { fetch } from 'whatwg-fetch'
import salesforceConfig from './salesforceConfig.mjs';

const getCognitoToken = async () => {
	const response = await fetch(salesforceConfig().cognitoUrl, {method: 'POST', headers: salesforceConfig().headers, body: salesforceConfig().body});
	const res = await response.json();
	if(res && res.access_token)
		return res.access_token

	throw new Error('Failed to get cognito response')
}

export default getCognitoToken;
